import { faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Booker } from '../types';

interface Props {
    booker: Booker;
    // omit to render a read-only indicator (used wherever the confirmation itself lives elsewhere)
    onToggle?: (verified: boolean) => void;
    disabled?: boolean;
}

/**
 * Per-booker attendance indicator — green once confirmed, grey while open. With `onToggle` it
 * becomes a button an admin can use to confirm or withdraw that single booker's attendance.
 */
const AttendanceBookerToggle = ({ booker, onToggle, disabled }: Props) => {
    const { t } = useTranslation('space-manager');
    const isVerified = !!booker.verified_at;

    const title = isVerified
        ? t('attendance.booker.verifiedAt', { date: moment(booker.verified_at).format('DD.MM.YY HH:mm') })
        : t('attendance.booker.open');

    const className = isVerified ? 'tw-text-success' : 'tw-text-accents-4';

    if (!onToggle) {
        return (
            <span className={className} title={title}>
                <FontAwesomeIcon icon={faUserCheck} />
            </span>
        );
    }

    return (
        <button
            type="button"
            title={
                isVerified ? t('attendance.booker.withdrawTooltip') : t('attendance.booker.confirmTooltip')
            }
            aria-label={title}
            disabled={disabled}
            className={`tw-cursor-pointer tw-border-none tw-bg-transparent tw-p-0 disabled:tw-opacity-50 ${className}`}
            onClick={() => onToggle(!isVerified)}
        >
            <FontAwesomeIcon icon={faUserCheck} />
        </button>
    );
};

export default AttendanceBookerToggle;
